export default __webpack_public_path__ + "static/media/alan.cd6bf15a.jpeg";